import apiClient from './apiClient';

// F105 interface matching backend model
export interface F1051 {
  f1051_01: string;  // 庫位代號
  f1051_02: number;  // 序號
  f1051_11: string;  // 控管人員代號
}

export interface F105 {
  f105_01: string;           // 庫位代號
  f105_11: string;           // 庫位名稱
  f105_12: string;           // 庫位簡稱
  f105_13: string;           // 地址
  f105_14: string;           // 聯絡人
  f105_15: string;           // 電話
  f105_16: boolean;          // 客戶寄庫
  f105_17: boolean;          // 庫位控管
  f105_19: boolean;          // 控管員工有無旗標
  f105_20: string;           // 庫位等級
  f105_18: boolean;          // 慶佑庫位
  f105_91: string;           // 建立人員代號
  f105_92: string | null;    // 建立日期
  f105_93: string;           // 最後異動人員代號
  details?: F1051[];         // 控管人員明細
}

export interface ListResponse {
  data: F105[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

export interface F106Option {
  code: string;
  name: string;
}

const BASE = '/api/warehouse-location';

const warehouseLocationApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (code: string): Promise<F105> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(code)}`);
    return res.data;
  },

  create: async (data: Partial<F105>): Promise<F105> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (code: string, data: Partial<F105>): Promise<F105> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  delete: async (code: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
  },

  listLevels: async (): Promise<F106Option[]> => {
    const res = await apiClient.get(`${BASE}/levels`);
    return res.data || [];
  },

  lookupEmployee: async (code: string): Promise<{ code: string; name: string }> => {
    const res = await apiClient.get(`${BASE}/employee/${encodeURIComponent(code)}`);
    return res.data;
  },
};

export default warehouseLocationApi;
